module.exports = __webpack_public_path__ + "static/img/banner02.206f8cc0.png";